var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"width":"16px"}},[_c('rir-button',{attrs:{"color":_vm.colorIcon,"transparent":"","icon":_vm.iconFavorite},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.changeFavorite($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }